import Base from "@/api/Base";

export const ACTION_PUBLISH = 'publish';
export const ACTION_UNPUBLISH = 'unpublish';

export default class Change extends Base
{
	setJobId (v)
	{
		this.jobId = v;
		return this;
	}

	setAction (v)
	{
		this.data.action = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/kandidat/job/' + this.jobId + '/status';
	}
}
